/* eslint-disable react/jsx-no-useless-fragment */
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import RiskAssessmentDetail from './components/RiskAssessmentDetail';

const Main: React.FC = () => {
  const { state } = useLocation();

  const datasets = useMemo(() => {
    if (state?.assessment) {
      return state.assessment.datasets;
    }
    return [];
  }, [state]);

  const aiSystems = useMemo(() => {
    if (state?.assessment) {
      return state.assessment.aiSystems;
    }
    return [];
  }, [state]);

  const template = useMemo(() => {
    if (state?.assessment) {
      return state.assessment.template;
    }
    return [];
  }, [state]);

  const assessmentIds = useMemo(() => {
    if (state?.assessment) {
      return state.assessment.assessmentIds;
    }
    return [];
  }, [state]);

  const userResponses = useMemo(() => {
    if (state?.assessment) {
      return state.assessment.userResponses;
    }
    return [];
  }, [state]);

  return (
    <>
      {template && (
        <RiskAssessmentDetail
          guestMode={false}
          templateDetail={template}
          aiSystems={aiSystems}
          datasets={datasets}
          assessmentIds={assessmentIds}
          userResponses={userResponses}
        />
      )}
    </>
  );
};

export default Main;
